import moment from "moment/moment";
import { DateFormatEnum } from "~/enums";

export default {
  methods: {
    /**
     * @param object
     * @param startKey
     * @param durationKey
     * @param endKey
     * @param {'start'|'duration'|'end'} attributeToSync
     * @param {'minutes'|'hours'|'days'|'months'|'years'} durationUnit
     * @param dateFormat
     * @param setFirstOfTheMonth
     */
    syncStartDurationEnd(object, startKey, durationKey, endKey, attributeToSync, durationUnit = "months", dateFormat = null, setFirstOfTheMonth = false) {
      switch (attributeToSync) {
        case "start":
          this.$set(
            object,
            startKey,
            moment(object[endKey])
              .subtract(object[durationKey], durationUnit)
              .startOf(setFirstOfTheMonth ? "month" : "undefined")
              .format(dateFormat ?? DateFormatEnum.DATE),
          );
          break;
        case "duration":
          this.$set(
            object,
            durationKey,
            Math.max(
              0,
              moment(object[endKey])
                .startOf(durationUnit)
                .diff(
                  moment(object[startKey]).startOf(durationUnit),
                  durationUnit,
                ),
            ),
          );
          break;
        case "end":
          this.$set(
            object,
            endKey,
            moment(object[startKey])
              .add(object[durationKey], durationUnit)
              .startOf(setFirstOfTheMonth ? "month" : "undefined")
              .format(dateFormat ?? DateFormatEnum.DATE),
          );
          break;
        default:
          throw new Error("invalid attributeToSync given");
      }
    },
  },
};
